$(function () {

    // find IndexMethod polyfill for IE
    if (!Array.prototype.findIndex) {
        Object.defineProperty(Array.prototype, 'findIndex', {
            value: function(predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return k.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return k;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return -1.
                return -1;
            },
            configurable: true,
            writable: true
        });
    }


    function showPrice() {
        setTimeout(function(){
            $('#date-selection .ui-datepicker-calendar tbody td').each(function () {
                if($(this).hasClass('has-price')) {
                    var results = $(this).attr("class").match(/price-\d+/i);
                    var price = results&&results.length>0?results[0].split('-')[1]:'0';
                    if($.isNumeric(price) && price !== '0') { 
                        $(this).append('<span class="price">$'+price+'</span>');
                    } else {
                        $(this).append('<span class="sold-out">Sold Out</span>');
                    }
                }
            });
        },  0);
        console.log('update prices');
    }

    const months = ["Jan","Feb","March","April","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"];

    function changeDateHTML(target, day, month){
        target.html("<span>"+ day + "</span>" + month);
    }

    const CheckIn__selector = $("#checkIn--date"),
        CheckOut__selector = $("#checkOut--date");

    $.post(site_url + "ajax/functions.php", {
        operation: 'getDayPricesFromTravelTripper',
        hotel_id: "BAHSBR",
        portal_id: "sandyportresort",
        number_of_months: 12
    }, function(data) {

        const dataDates = data.dates;
        const dataPrices =  data.prices;

        $.datepicker._defaults.dateFormat = "yy-mm-dd";

        $('#date-selection').datepicker({
            inline: true,
            numberOfMonths: 2,
            minDate: 0,
            changeMonth: false,
            beforeShowDay: function(date) {
                let startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim($("#CheckIn--alt").val())),
                    endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim($("#CheckOut--alt").val())),
                    dmy =  date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2) ;

                if ($.inArray(dmy, dataDates) != -1) {
                    let index = dataDates.findIndex(x =>x==dmy),
                        style = startDate && ((date.getTime() == startDate.getTime())|| (endDate && date >= startDate && date <= endDate) ) ? "dp-highlight " : "";

                    return [true,' has-price ' + style + 'price-' + dataPrices[index]];
                } else {
                    return [true, startDate && ((date.getTime() == startDate.getTime()) || (endDate && date >= startDate && date <= endDate) ) ? "dp-highlight" : ""];
                }
            },
            onChangeMonthYear: function(date) {
                showPrice();
            },
            onSelect: function (date) {
                // console.log('onSelect', date);
                let date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim( $("#CheckIn--alt").val()) ),
                    date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim( $("#CheckOut--alt").val()) ),
                    selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date),

                //DATE SELECTED
                thisDate = $(this).datepicker('getDate'),
                    day  = thisDate.getDate(),
                    month = months[thisDate.getMonth()];

                if (!date1 || date2) {
                    $("#CheckIn--alt").val(date);
                    $("#CheckOut--alt").val("");

                    changeDateHTML(CheckIn__selector, day, month);
                    // console.log('checkin');
                } else if( selectedDate < date1 ) {
                    $("#CheckIn--alt").val(date);
                    $("#CheckOut--alt").val("");

                    changeDateHTML(CheckIn__selector, day, month);
                    // console.log('change dates');
                } else {
                    $("#CheckOut--alt").val(date);

                    changeDateHTML(CheckOut__selector, day, month);
                    // console.log('checkout');
                }
                showPrice();
            }
        });

        showPrice();

    }, "json");

});